import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { Stack, Alert, Button } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { sendOtp } from '../../../services/authServices';
import RHFTextField from '../../../components/hook-form/RHFTextField';
import { fixDigits } from '../../../utils/fixDigits';
import useAuth from '../../../hooks/useAuth';
import { snackActions } from '../../../components/notistack/SnackbarUtilsConfigurator';
import { FormProvider } from '../../../components/hook-form';
import { useEffect } from 'react';
import { t } from 'i18next';

const SendOtpForm = ({ username, setStep }) => {
  const { login } = useAuth();

  const schema = Yup.object().shape({
    code: Yup.string().required('کد احراز هویت را وارد کنید'),
  });

  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: { code: '' },
  });

  const {
    handleSubmit,
    setValue,
    formState: { isSubmitting },
  } = methods;

  const onSubmit = async (data) => {
    const normalizedCode = fixDigits(data.code);
    const response = await sendOtp({ username, code: normalizedCode });

    if (response.status < 500 && response.data.status_code === 2000) {
      await login(response.data.data);
      snackActions.success('ورود با موفقیت انجام شد.');
    }
  };

  useEffect(() => {
    if (!("OTPCredential" in window)) return;

    const controller = new AbortController();

    navigator.credentials
      .get({
        otp: { transport: ["sms"] },
        signal: controller.signal,
      })
      .then((otp) => {
        if (otp?.code) {
          setValue('code', otp.code);
          handleSubmit(onSubmit)();
        }
      })
      .catch(() => {});

    return () => controller.abort();
  }, []);

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Stack spacing={3}>
        <Alert severity="info">{t('enter_otp_code')}</Alert>

        <RHFTextField name="code" label="کد احراز هویت" autoComplete="one-time-code" type="tel" inputMode="tel" />
        <LoadingButton fullWidth size="large" type="submit" variant="contained" loading={isSubmitting}>
          ورود
        </LoadingButton>

        <Stack direction="row" justifyContent="flex-start">
          <Button onClick={() => setStep(0)}>اصلاح شماره تلفن</Button>
        </Stack>
      </Stack>
    </FormProvider>
  );
};

export default SendOtpForm;